export default __webpack_public_path__ + "static/media/Immagine_8.c22ae316.jpg";